// src/components/auth/ResetPassword.jsx
import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import './auth.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

const ResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!token) {
      setError('Missing reset token. Please use the link from your email.');
      return;
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        // NOTE: backend expects { token, password }
       body: JSON.stringify({ token, newPassword: password }),
      });
      const data = await res.json();

      if (res.ok && data.success) {
        setDone(true);
        setTimeout(() => navigate('/login'), 2500);
      } else {
        setError(data.error || 'This reset link is invalid or has expired.');
      }
    } catch (err) {
      console.error('Reset error:', err);
      setError('Could not reach the server. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="auth__page">
        <div className="auth__container">
          <div className="auth__box" style={{ textAlign: 'center' }}>
            <i className="bx bx-check-circle" style={{ fontSize: 56, color: '#43e97b' }}></i>
            <h2>Password updated</h2>
            <p>Your password has been changed. Redirecting you to sign in…</p>
            <Link to="/login" className="auth__button button button--flex" style={{ marginTop: '1rem' }}>
              Go to Login
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth__page">
      <div className="auth__container">
        <div className="auth__box">
          <Link to="/" className="auth__home">
            <i className="bx bx-home"></i> Back to Home
          </Link>

          <div className="auth__header">
            <h2>Set a New Password</h2>
            <p>Enter and confirm your new password below.</p>
          </div>

          {error && (
            <div className="auth__error">
              <i className="bx bx-error-circle"></i>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="auth__form">
            <div className="auth__field">
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="New password (min 8 characters)"
                required
                minLength="8"
              />
              <i className="bx bx-lock"></i>
            </div>

            <div className="auth__field">
              <input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                placeholder="Confirm new password"
                required
                minLength="8"
              />
              <i className="bx bx-lock"></i>
            </div>

            <button type="submit" className="auth__button button button--flex" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Updating…
                </>
              ) : (
                <>
                  <i className="bx bx-check"></i>
                  Update Password
                </>
              )}
            </button>
          </form>

          <div className="auth__footer">
            <p>
              Remembered it? <Link to="/login">Sign In</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;